import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-delete2",
  "use": "icon-delete2-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-delete2\"><defs><style type=\"text/css\"></style></defs><path d=\"M512 64C264.57 64 64 264.57 64 512s200.58 448 448 448 448-200.58 448-448S759.42 64 512 64z m256 512H256c-35.2 0-64-28.8-64-64s28.8-64 64-64h512c35.2 0 64 28.8 64 64s-28.8 64-64 64z\" fill=\"#ff0000\" p-id=\"9648\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol